module.exports = {"content":{},"productInfo":{"code":"{5751F7DB-E66C-4469-B6F8-33E5A8792560}","name":"韓国語　初中級","serialHead":"ZTEMM","courseResourceIDs":[{"levelNo":1,"resourceID":"978bd3862f4be16b3c309807136eb55017bb79c5"},{"levelNo":2,"resourceID":"e41ec747508353bbeab107a554e8db203dad6ab3"},{"levelNo":3,"resourceID":"c5cb8dd79e61b7d7b7a5a9e453978e357ac3d2fd"}],"language":"ko-KR","challengeCount":21531},"version":"1.1.0"}


//////////////////
// WEBPACK FOOTER
// ./static/data.json
// module id = 207
// module chunks = 1